import { render, staticRenderFns } from "./HaberKategoriDetay.vue?vue&type=template&id=fd0dcfee&scoped=true&"
import script from "./HaberKategoriDetay.vue?vue&type=script&lang=js&"
export * from "./HaberKategoriDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0dcfee",
  null
  
)

export default component.exports